/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { TierStepsResponseDTO } from './TierStepsResponseDTO';

export type TierUpgradeStatusResponseDTO = {
    generalProcessStatus?: TierUpgradeStatusResponseDTO.generalProcessStatus;
    tierSteps?: Array<TierStepsResponseDTO>;
    tierType?: TierUpgradeStatusResponseDTO.tierType;
};

export namespace TierUpgradeStatusResponseDTO {

    export enum generalProcessStatus {
        STARTED = 'STARTED',
        PENDING = 'PENDING',
        APPROVED = 'APPROVED',
        REJECTED = 'REJECTED',
        DISCARDED = 'DISCARDED',
        BLOCKED = 'BLOCKED',
    }

    export enum tierType {
        BRONZE = 'BRONZE',
        SILVER = 'SILVER',
        GOLD = 'GOLD',
        PLATINUM = 'PLATINUM',
    }


}

